import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IOptionInfo } from '../../../event/models/event.model';
import { IActionCampaignModel } from '../../../campaign/models/campaign.model';
import { AuctionHelperService } from '../../../core/services/auction-helper.service';
import { ItemsType, ItemTypeText } from '../../../campaign/models/activity.model';

@Component({
  selector: 'app-featured-items',
  templateUrl: './featured-items.component.html',
  styleUrls: ['./featured-items.component.scss']
})
export class FeaturedItemsComponent implements OnInit, AfterViewInit  {

  @ViewChild('swiper') swiperRef: ElementRef;

  @Input() public items: IOptionInfo[] = [];
  @Input() public title = 'Recommended Items';
  @Input() public type = ItemsType.featured;
  @Input() public campaign: IActionCampaignModel;
  @Input() public quickPledge: any;

  public itemType = ItemTypeText;
  public types = ItemsType;

  public config = {};

  constructor(
    public auctionHelperService: AuctionHelperService
  ) { }

  ngOnInit() {
    this.config = {
      navigation: {
        nextEl: '#next',
        prevEl: '#prev'
      },
      allowTouchMove: true,
      slidesPerView: 'auto',
      updateOnWindowResize: true,
      resizeObserver: true
    }
  }

  ngAfterViewInit() {
    new window['Swiper'](this.swiperRef.nativeElement, this.config);
  }

  getImageUrl(item) {
    return item.imageUrl || '/images/org_logo_default_v2.svg';
  }

  identify(index) {
    return index;
  }

  getButtonText(bid) {
    const soldOut = bid.soldCount >= bid.count;
    return soldOut ? 'Sold Out' : 'Bid Again';
  }

  bidAgain(bid) {
    this.quickPledge.selectedPreset = bid;
    this.quickPledge.payeeInfo.selectedPreset = bid;

    this.quickPledge.showBidConfirm({ id: 'bidFromSuccess_' + this.campaign.id + '_' + bid.id }, true, this.campaign.id, bid.id);
  }

  buyItNow(bid) {
    this.quickPledge.selectedPreset = bid;
    this.quickPledge.payeeInfo.selectedPreset = bid;
    this.quickPledge.showBuyItNow({ id: 'id_' + this.campaign.id + '_' + bid.id }, {
      campaignId: this.campaign.id,
      optionInfo: bid,
    }, true);
  }

  buttonClass(bid) {
    const soldOut = bid.soldCount >= bid.count;
    return {
      'button--sold-out': soldOut,
    };
  }

  buttonDisabled(bid) {
    const { status } = this.quickPledge.getAuctionStatus( this.campaign.campaignTypeData);
    if (status !== 0) {
      return true;
    }

    if (bid.buyItNowOnlyItem) {
      return true;
    }

    return bid.soldCount >= bid.count;
  }
}
